export default async function fetchBotStatus(url) {
    return fetch(`${import.meta.env.VITE_APP_API_URL}${url}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      return data;
    })
    .catch(error => {
      console.error('Error en la solicitud:', error);
    });
  }